<template>
  <mdb-container>
    <mdb-card class="mb-4">
      <mdb-card-header><h4>Assembling Players</h4></mdb-card-header>
      <mdb-card-body>
        <h3>New Players need this secret phrase to get in: <i>{{ game.gameCode }}</i></h3>
        <div class="text-info">
          <p>Group members may join from the Group Menu under More -> Campfire</p>
          <p>...OR Share Link:</p>
          <p>
            <mdb-btn icon="link" @click="copyLink">Copy Link to Clipboard</mdb-btn>
          </p>
          <p>
            <mdb-btn icon="qrcode" @click="qrModal = true">Share via QR Code</mdb-btn>
          </p>
        </div>
      </mdb-card-body>
    </mdb-card>
    <mdb-card class="mb-4">
      <mdb-card-header class="secondary-color"><h5>Current Players</h5></mdb-card-header>
      <mdb-card-body class="text-left">
        <div v-for="(player,i) in currentState.players" :key="i" class="mb-2">
          <avatar :avatar="player.avatar" :name="player.name"/>
          <p>{{ player.name }}</p>
          <p v-if="game.isHost && player.playerId != currentState.myPlayerId">
            <mdb-btn icon="user-minus" @click="removePlayer(player)" size="sm" color="danger" rounded>Remove from Game
            </mdb-btn>
          </p>
          <div class="gp-end-wrap"></div>
        </div>
        <div v-if="game.isHost">
          <mdb-btn v-if="currentState.players.length>=currentState.minPlayers" icon="check" @click="doneAssembling">
            Everyone's Here
          </mdb-btn>
          <div v-if="currentState.players.length<currentState.minPlayers" class="small">You need at least
            {{ currentState.minPlayers }} players to begin.
          </div>
        </div>
        <div v-else>
          <mdb-spinner/>
          Waiting for {{ game.host }} to start game once everyone is here.
        </div>
      </mdb-card-body>
    </mdb-card>
    <mdb-modal :show="qrModal" class="text-center" size="lg" @close="qrModal=false">
      <mdb-modal-header :close="true" center >
        <h3 class="heading">QR Code</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <p>Have player(s) scan this code to join the game.</p>
        <qrcode-vue :value="joinLink" :size="300" level="H"></qrcode-vue>
      </mdb-modal-body>
    </mdb-modal>


  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbSpinner
} from 'mdbvue';
import Avatar from "../common/Avatar";
import QrcodeVue from 'qrcode.vue'

export default {
  name: "group-campfire-join",
  props: {
    currentState: {
      type: Object,
      default: null
    },
    game: {
      type: Object,
      default: null
    }
  },
  components: {
    Avatar,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbContainer,
    mdbSpinner,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    QrcodeVue
  },
  computed: {
    settings() {
      return this.$store.state.settings
    },
    joinLink() {
      return this.settings.frontEndUrl + '/play-campfire/' + this.game.sessionId + "/?code=" + encodeURIComponent(this.game.gameCode)
    }
  },
  data() {
    return {
      qrModal: false
    }
  },
  beforeDestroy() {

  },
  mounted() {

  },
  methods: {
    async copyLink() {
      if (!navigator.clipboard) {
        this.$notify.error({message: "Your browser does not support copying to clipboard.", timeOut: 2500})
        return
      }
      try {
        await navigator.clipboard.writeText(this.joinLink)
        this.$notify.success({message: "Link copied to clipboard.", timeOut: 2500})
      } catch (e) {
        this.$notify.error({message: "Error copying to clipboard." + e, timeOut: 2500})
      }
    },
    ignoreClick() {
      return
    },
    doneAssembling() {
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/assemblyDone/" + this.game.sessionId, {accessToken: this.game.accessToken}).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    removePlayer(player) {
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/remove/" + this.game.sessionId, {
        accessToken: this.game.accessToken,
        playerId: player.playerId
      }).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};

</script>
